module.exports = __webpack_public_path__ + "img/upperabs-ectomorph-male.21d9a55a.svg";